/**
 * Where to go after sign-in + onboarding (v6.1: an invite link → sign in →
 * onboard → back to /d/:token). Survives the redirect chain and a reload in
 * sessionStorage. Only same-origin app paths are accepted (no open redirects).
 */
const KEY = 'popin.returnTo';

export function safePath(p: unknown): string | null {
  if (typeof p !== 'string' || !p.startsWith('/') || p.startsWith('//') || p.startsWith('/\\')) return null;
  if (p.length > 300 || /[\s<>]/.test(p)) return null;
  return p;
}

export function setReturnTo(path: string): void {
  const p = safePath(path);
  if (!p) return;
  try {
    sessionStorage.setItem(KEY, p);
  } catch {
    /* storage blocked: the flow still works, it just lands on /home */
  }
}

export function peekReturnTo(): string | null {
  try {
    return safePath(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
}

/** Read and clear. */
export function consumeReturnTo(): string | null {
  const p = peekReturnTo();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return p;
}
